var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "py-6" }, [
    _c("h3", { staticClass: "text-lg font-medium mb-4" }, [
      _vm._v("Step 4 of 9: Health Information"),
    ]),
    _vm._m(0),
    _c(
      "div",
      { staticClass: "grid grid-cols-1 gap-3" },
      [
        _c(
          "ValidationProvider",
          { attrs: { name: "Medical Conditions" } },
          [
            _c(
              "FormGroup",
              {
                attrs: { title: "" },
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticClass: "mainTtile" }, [
                          _vm._v(" Medical Conditions "),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("FormInputGroup", {
                  attrs: {
                    name: "medical_conditions",
                    placeholder: "Enter medical conditions",
                    inputClass: "w-full",
                    invalid: _vm.failed,
                  },
                  on: {
                    input: (val) => _vm.updateField("medical_conditions", val),
                  },
                  model: {
                    value: _vm.formData.medical_conditions,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "medical_conditions", $$v)
                    },
                    expression: "formData.medical_conditions",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "ValidationProvider",
          { attrs: { name: "Past Conditions" } },
          [
            _c(
              "FormGroup",
              {
                attrs: { title: "", errors: _vm.errors },
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticClass: "mainTtile" }, [
                          _vm._v(" Past Conditions "),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("FormInputGroup", {
                  attrs: {
                    name: "past_conditions",
                    placeholder: "Enter past conditions",
                    inputClass: "w-full",
                    invalid: _vm.failed,
                  },
                  on: {
                    input: (val) => _vm.updateField("past_conditions", val),
                  },
                  model: {
                    value: _vm.formData.past_conditions,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "past_conditions", $$v)
                    },
                    expression: "formData.past_conditions",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-span-1" },
          [
            _c("h4", { staticClass: "text-base font-medium mb-1" }, [
              _vm._v(" Medications: Current Medications "),
            ]),
            _vm._l(
              _vm.formData.client_medications,
              function (medication, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "grid grid-cols-1 gap-4 mb-4" },
                  [
                    _c(
                      "ValidationProvider",
                      { attrs: { name: `Medication Name ${index + 1}` } },
                      [
                        _c(
                          "FormGroup",
                          {
                            attrs: { title: "", errors: _vm.errors },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _c("p", { staticClass: "mainTtile" }, [
                                        _vm._v(" Enter Medication Name "),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("FormInputGroup", {
                              attrs: {
                                name: `medication-name-${index}`,
                                placeholder: "Enter medication name",
                                inputClass: "w-full",
                                invalid: _vm.failed,
                              },
                              on: {
                                input: (val) =>
                                  _vm.updateMedication(index, "name", val),
                              },
                              model: {
                                value: medication.name,
                                callback: function ($$v) {
                                  _vm.$set(medication, "name", $$v)
                                },
                                expression: "medication.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "grid grid-cols-2 gap-4 mb-4" },
                      [
                        _c(
                          "ValidationProvider",
                          { attrs: { name: `Medication Dosage ${index + 1}` } },
                          [
                            _c(
                              "FormGroup",
                              {
                                attrs: { title: "", errors: _vm.errors },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c(
                                            "p",
                                            { staticClass: "mainTtile" },
                                            [_vm._v(" Dosage ")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("FormInputGroup", {
                                  attrs: {
                                    name: `medication-dosage-${index}`,
                                    placeholder: "Enter medication dosage",
                                    inputClass: "w-full",
                                    invalid: _vm.failed,
                                  },
                                  on: {
                                    input: (val) =>
                                      _vm.updateMedication(
                                        index,
                                        "dosage",
                                        val
                                      ),
                                  },
                                  model: {
                                    value: medication.dosage,
                                    callback: function ($$v) {
                                      _vm.$set(medication, "dosage", $$v)
                                    },
                                    expression: "medication.dosage",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "ValidationProvider",
                          {
                            attrs: {
                              name: `Medication Frequency ${index + 1}`,
                            },
                          },
                          [
                            _c(
                              "FormGroup",
                              {
                                attrs: { title: "", errors: _vm.errors },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c(
                                            "p",
                                            { staticClass: "mainTtile" },
                                            [_vm._v(" Frequency ")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("FormInputGroup", {
                                  attrs: {
                                    name: `medication-frequency-${index}`,
                                    placeholder: "Enter medication frequency",
                                    inputClass: "w-full",
                                    invalid: _vm.failed,
                                  },
                                  on: {
                                    input: (val) =>
                                      _vm.updateMedication(
                                        index,
                                        "frequency",
                                        val
                                      ),
                                  },
                                  model: {
                                    value: medication.frequency,
                                    callback: function ($$v) {
                                      _vm.$set(medication, "frequency", $$v)
                                    },
                                    expression: "medication.frequency",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "ValidationProvider",
                      { attrs: { name: `Medication File ${index + 1}` } },
                      [
                        _c(
                          "FormGroup",
                          {
                            attrs: { title: "", errors: _vm.errors },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _c("p", { staticClass: "mainTtile" }, [
                                        _vm._v(" Medication File Attached "),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("FormSelect", {
                              attrs: {
                                getParentCustom: "clientWidth",
                                name: `medication-file-${index}`,
                                placeholder: "Select",
                                options: [
                                  { label: "Yes", value: "Yes" },
                                  { label: "No", value: "No" },
                                ],
                                inputClass: "w-full",
                              },
                              on: {
                                input: (val) => {
                                  _vm.consoel.log(val)
                                  _vm.updateMedication(index, "file", val)
                                },
                              },
                              model: {
                                value: medication.file,
                                callback: function ($$v) {
                                  _vm.$set(medication, "file", $$v)
                                },
                                expression: "medication.file",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }
            ),
            _c(
              "div",
              { staticClass: "flex items-center space-x-4 mt-4" },
              [
                _c("UIButton", {
                  attrs: { variant: "primary", buttonText: "Save", size: "lg" },
                  on: { click: _vm.saveMedications },
                }),
                _c("UIButton", {
                  attrs: {
                    variant: "outline",
                    buttonText: "Add new Medication",
                    size: "lg",
                  },
                  on: { click: _vm.addNewMedication },
                  scopedSlots: _vm._u([
                    {
                      key: "icon",
                      fn: function () {
                        return [_c("HoveredIcon", { staticClass: "w-4 h-4" })]
                      },
                      proxy: true,
                    },
                    {
                      key: "hover-icon",
                      fn: function () {
                        return [_c("HoveredIcon", { staticClass: "w-6 h-6" })]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "grid grid-cols-1 gap-3" },
          [
            _c("h4", { staticClass: "text-base font-medium mb-1" }, [
              _vm._v("Allergies"),
            ]),
            _c(
              "ValidationProvider",
              { attrs: { name: "Food Allergies" } },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: { title: "", errors: _vm.errors },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mainTtile" }, [
                              _vm._v("Food"),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormInputGroup", {
                      attrs: {
                        getParentCustom: "clientWidth",
                        name: "allergies_food",
                        placeholder: "Enter food",
                        inputClass: "w-full",
                        invalid: _vm.failed,
                      },
                      on: {
                        input: (val) => _vm.updateField("allergies_food", val),
                      },
                      model: {
                        value: _vm.formData.allergies_food,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "allergies_food", $$v)
                        },
                        expression: "formData.allergies_food",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "ValidationProvider",
              { attrs: { name: "Medication Allergies" } },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: { title: "", errors: _vm.errors },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mainTtile" }, [
                              _vm._v(" Medication "),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormInputGroup", {
                      attrs: {
                        name: "allergies_medication",
                        getParentCustom: "clientWidth",
                        placeholder: "Enter medication",
                        inputClass: "w-full",
                        invalid: _vm.failed,
                      },
                      on: {
                        input: (val) =>
                          _vm.updateField("allergies_medication", val),
                      },
                      model: {
                        value: _vm.formData.allergies_medication,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "allergies_medication", $$v)
                        },
                        expression: "formData.allergies_medication",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "ValidationProvider",
              { attrs: { name: "Environmental Allergies" } },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: { title: "", errors: _vm.errors },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mainTtile" }, [
                              _vm._v(" Environmental "),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormInputGroup", {
                      attrs: {
                        getParentCustom: "clientWidth",
                        name: "allergies_environmental",
                        placeholder: "Enter environmental",
                        inputClass: "w-full",
                        invalid: _vm.failed,
                      },
                      on: {
                        input: (val) =>
                          _vm.updateField("allergies_environmental", val),
                      },
                      model: {
                        value: _vm.formData.allergies_environmental,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "allergies_environmental", $$v)
                        },
                        expression: "formData.allergies_environmental",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "grid grid-cols-1 gap-3" },
          [
            _c("h4", { staticClass: "text-base font-medium mb-1" }, [
              _vm._v("Medical History"),
            ]),
            _c(
              "ValidationProvider",
              { attrs: { name: "Previous Hospitalizations" } },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: { title: "", errors: _vm.errors },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(" Previous Hospitalizations "),
                              _c("span", { staticClass: "subText" }, [
                                _vm._v("(optional)"),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormInputGroup", {
                      attrs: {
                        name: "previous_hospitalizations",
                        placeholder: "Enter previous hospitalizations",
                        inputClass: "w-full",
                      },
                      on: {
                        input: (val) =>
                          _vm.updateField("previous_hospitalizations", val),
                      },
                      model: {
                        value: _vm.formData.previous_hospitalizations,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.formData,
                            "previous_hospitalizations",
                            $$v
                          )
                        },
                        expression: "formData.previous_hospitalizations",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "ValidationProvider",
              { attrs: { name: "Past Surgeries" } },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: { title: "", errors: _vm.errors },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(" Past Surgeries "),
                              _c("span", { staticClass: "subText" }, [
                                _vm._v("(optional)"),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormInputGroup", {
                      attrs: {
                        name: "past_surgeries",
                        placeholder: "Enter past surgeries",
                        inputClass: "w-full",
                      },
                      on: {
                        input: (val) => _vm.updateField("past_surgeries", val),
                      },
                      model: {
                        value: _vm.formData.past_surgeries,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "past_surgeries", $$v)
                        },
                        expression: "formData.past_surgeries",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "ValidationProvider",
              { attrs: { name: "Immunizations" } },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: { title: "", errors: _vm.errors },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(" Immunizations "),
                              _c("span", { staticClass: "subText" }, [
                                _vm._v("(optional)"),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormInputGroup", {
                      attrs: {
                        name: "immunizations",
                        placeholder: "Enter immunizations",
                        inputClass: "w-full",
                      },
                      on: {
                        input: (val) => _vm.updateField("immunizations", val),
                      },
                      model: {
                        value: _vm.formData.immunizations,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "immunizations", $$v)
                        },
                        expression: "formData.immunizations",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "ValidationProvider",
              { attrs: { name: "Family Medical History" } },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: {
                      title: "Family Medical History",
                      errors: _vm.errors,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(" Family Medical History "),
                              _c("span", { staticClass: "subText" }, [
                                _vm._v("(optional)"),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormInputGroup", {
                      attrs: {
                        name: "family_medical_history",
                        placeholder: "Enter family medical history",
                        inputClass: "w-full",
                      },
                      on: {
                        input: (val) =>
                          _vm.updateField("family_medical_history", val),
                      },
                      model: {
                        value: _vm.formData.family_medical_history,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "family_medical_history", $$v)
                        },
                        expression: "formData.family_medical_history",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "grid grid-cols-1 gap-3" },
          [
            _c("h4", { staticClass: "text-base font-medium mb-1" }, [
              _vm._v(" Do Not Resuscitate (DNR) Order "),
            ]),
            _c(
              "ValidationProvider",
              { attrs: { name: "DNR Order" } },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: { title: "", errors: _vm.errors },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(" Do Not Resuscitate (DNR) Order "),
                              _c("span", { staticClass: "subText" }, [
                                _vm._v("(optional)"),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormSelect", {
                      attrs: {
                        name: "dnr_order",
                        getParentCustom: "clientWidth",
                        placeholder: "Select",
                        options: [
                          { label: "Yes", value: "Yes" },
                          { label: "No", value: "No" },
                        ],
                        inputClass: "w-full",
                      },
                      on: {
                        input: (val) => {
                          _vm.updateField("dnr_order", val)
                        },
                      },
                      model: {
                        value: _vm.formData.dnr_order,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "dnr_order", $$v)
                        },
                        expression: "formData.dnr_order",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "ValidationProvider",
              { attrs: { name: "Copy Attached" } },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: { title: "", errors: _vm.errors },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _c("span", [_vm._v("Copy Attached")]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormSelect", {
                      attrs: {
                        name: "dnr_copy_attached",
                        getParentCustom: "clientWidth",
                        placeholder: "Select",
                        options: [
                          { label: "Yes", value: "yes" },
                          { label: "No", value: "no" },
                        ],
                        inputClass: "w-full",
                      },
                      on: {
                        input: (val) => {
                          _vm.updateField("dnr_copy_attached", val)
                        },
                      },
                      model: {
                        value: _vm.formData.dnr_copy_attached,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "dnr_copy_attached", $$v)
                        },
                        expression: "formData.dnr_copy_attached",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-md mb-2 font-medium" }, [
        _vm._v("Current Medical Status"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }